<script>
export default {
  name: "buyOffPlanSection",
  data() {
    return {};
  },
  components: {},
  methods: {
    goSearch() {
      this.$router.push({ path: "/property/search/results" });
    }
  }
};
</script>

<template>
  <el-row>
    <el-col :span="24" class="background-listing">
      <video
        class="video-style"
        controls
        src="https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/unifi-video/unifi-property.mp4"
        type="video/mp4"
      />
      <!--      <el-row>-->
      <!--        <el-col :span="24" style="display: flex; flex-direction: column; align-items: center">-->
      <!--          <video class="video-style" type="video/mp4" controls src="https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/unifi-video/unifi-property.mp4"/>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <!--      <el-row>-->
      <!--        <el-col :span="24" style="display: flex; flex-direction: row">-->
      <!--          <span class="u-connect-p">Looking to buy off the plan?</span>-->
      <!--        </el-col>-->
      <!--        <el-col :span="24" style="display: flex; flex-direction: row; margin-top: 30px">-->
      <!--          <span class="u-connect-paragraph">Welcome to UNIFI Property, the home for Australia's best opportunities in new properties. Discover the excitement of purchasing off-the-plan with a selection of new properties. Our transparent approach ensures a seamless experience, guiding you through the entire purchasing process. Explore our live pricelist and envision your future-ready home, knowing that we're committed to guiding you every step of the way. Our online reservation feature allows you to initiate the purchasing process effortlessly. Welcome to a world of possibilities in buying off-the-plan.</span>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <!--      <el-row style="width: 100%">-->
      <!--        <el-col-->
      <!--        @click="goSearch()"-->
      <!--         :span="24" style="display: flex; justify-content: center;">-->
      <!--          &lt;!&ndash; <el-button type="primary" class="u-connect-btn">Find a new listing</el-button> &ndash;&gt;-->
      <!--        </el-col>-->
      <!--      </el-row>-->
    </el-col>
  </el-row>
</template>

<style lang="postcss" scoped>
.u-connect-p {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 34px Metropolis, sans-serif;
  display: flex;
}

.u-connect-btn {
  color: #ffbe00;
  text-align: center;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  width: 100%;
  margin-top: 40px;
  font: 600 20px Metropolis, sans-serif;
}

.u-connect-paragraph {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.background-listing {
  display: flex;
  padding: 20px 0;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  /*background: linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), url('../../assets/four.jpeg'), lightgray 50% / cover no-repeat;*/
  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 100%),
    lightgray 50% / cover no-repeat;
}

.video-style {
  width: 98%;
  height: 250px;
}

@media only screen and (max-width: 375px) {
  .video-style {
    width: 98%;
    height: 150px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1300px) {
  .video-style {
    width: 98%;
    height: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/package/buyOffPlanSection.vue